import { render, staticRenderFns } from "./AddConsignment.vue?vue&type=template&id=6e3002fb&scoped=true"
import script from "./AddConsignment.vue?vue&type=script&lang=js"
export * from "./AddConsignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3002fb",
  null
  
)

export default component.exports